'use strict';

/**
 * Collection for sets
 *
 * @category   Collection
 * @module     collection.location
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var Collection = require('base/Colido.Collection');
var StorageModel = require('../models/storage');

var StoragesCollection = Collection.extend({
    api: function() {
        var api = '/storages';

        if (this.catalog) {
            api =  this.catalog.api + '/' + this.catalog.id + '/storages';
        }

        return api;
    },

    getName: function() {
        var name = 'collection:storages';

        if (this.catalog) {
            name =  this.catalog.collection.name + ':' + this.catalog.id + ':storages';
        }

        return name;
    },

    name: 'collection:locations:storages',

    model: StorageModel,

    sortDefault: 'name.asc',

    initialize: function(models, options) {
        options = options || {};

        if (!options.catalog) {
            return Colido.config.debug && console.log('You have to provide a catalog model as option when initializing a storages collection');
        }

        this.catalog = options.catalog;

        this.name = this.getName();

        this.applyPatchExtension();

        //start: Sync objects into storages (could be better handled via WS maybe?)
        this.listenTo(this.catalog.objects, 'add', function(object){
            var storage = this.get(object.get('storageId'));
            if (storage) {
                storage.addObject(object.id);
            }
        })

        this.listenTo(this.catalog.objects, 'remove', function(object){
            var storage = this.get(object.get('storageId'));
            if (storage) {
                storage.removeObject(object.id);
            }
        })

        this.listenTo(this.catalog.objects, 'change:storageId', function(object, storageId){
            this.moveObject(object, object.previous('storageId'), storageId);
        }.bind(this));
        //end sync

        this.listenTo(App.radio(this.name).vent, 'updated', function(data) {
            this.setFromWebsocket(data, {remove: false});
        }.bind(this));

        this.listenTo(App.radio(this.name).vent, 'removed', function(data) {
            this.remove(data); //data [1,2,3]
        }.bind(this));

        this.listenTo(App.radio(this.name).vent, 'added', function(data) {
            this.add(data);
        }.bind(this));

        //publish collection events
        this.on('destroy', function(model, collection){
            App.radio('collection').trigger('location:destroy', model, collection);
        });
    },

    moveObject: function(object, oldStorageId, newStorageId) {
        var oldStorage = this.get(oldStorageId);
        if (oldStorage) {
            oldStorage.removeObject(object.id);
        }

        var newStorage = this.get(newStorageId);
        if (newStorage) {
            newStorage.addObject(object.id);
        }
    },

    comparator: function(collection){
        return collection.get('sortOrder');
    },

    /**
     * Returns the unknown location
     * @returns {LocationModule.StorageModel}
     */
    getUnknowLocation: function() {
        return this.findWhere({name: 'Unknown'}) || new this.model();
    },

    /**
     * Retruns the nested storages collection
     * @returns {Colido.FilteredCollection}
     */
    getNestedCollection: function() {
        var filteredCollection = this.getFilteredCollection(function(model) {
            return model.get('isRoot') === 1 && model.get('storType') !== 'status';
        });

        if (this.catalog) {
            filteredCollection.catalog = this.catalog;
        }

        return filteredCollection;
    },

    /**
     * Returns the collection for RFID storages
     * @returns {Colido.FilteredCollection}
     */
    getRfidCollection: function() {
        var filteredCollection = this.getFilteredCollection(function(model) {
            return model.get('isRfid') === 1;
        });

        if (this.catalog) {
            filteredCollection.catalog = this.catalog;
        }

        return filteredCollection;
    },

    /**
     * Returns the collection for locations like transit | none | unknown
     * @returns {Colido.FilteredCollection}
     */
    getMetaStoragesCollection: function() {
        var filteredCollection = this.getFilteredCollection(function(model) {
            return model.get('storType') === 'status';
        });

        if (this.catalog) {
            filteredCollection.catalog = this.catalog;
        }

        return filteredCollection;
    },
});

module.exports = StoragesCollection;